import axios from 'axios'

export const getDashboard = ({ id }) => {
    return axios({
        url: `/gss-dashboard/stream-app`,
        method: `get`,
        params: { id }
    })
}
